import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=541f0faf&scoped=true&"
import script from "./Search.ts?vue&type=script&lang=ts&"
export * from "./Search.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541f0faf",
  null
  
)

export default component.exports